import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 계획 상세(수요/작업주문 단위 activity 목록, 자유 그룹핑 화면) — AnalysisController#getPlanDetail
// (백엔드는 factoryplan/analysis/fp-plan-detail). DispatchList와 같은 평평한 목록
// { data: PlanDetailDto[] }. old도 그리드 조회(loadData) 하나뿐 — 차트/드릴다운 없음
// (fp-report-screen-guide.md §B, 자유 그룹핑 변형 §B-6).
const getPlanDetail = (params) => fpApiUtil.postParams(`${ANALYSIS}/fp-plan-detail`, params);

const fpPlanDetailService = { getPlanDetail };
export default fpPlanDetailService;
